import { render, staticRenderFns } from "./UnsettledComponent.vue?vue&type=template&id=7ac5f30c&"
import script from "./UnsettledComponent.vue?vue&type=script&lang=ts&"
export * from "./UnsettledComponent.vue?vue&type=script&lang=ts&"
import style0 from "./UnsettledComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports